import React, { useEffect, useState } from 'react';
import SalesOrderFieldCustomisation from './components/salesOrderFieldCustomisation';
import SalesOrderGeneral from './components/salesOrderGeneral';
import { toast } from 'react-toastify';
import { stringToBool } from '../../../../../utils/utility';
import {
	getSalesOrderGeneral,
	UpdateSalesOrderGeneral,
	UpdateSaleSOrderGeneral,
} from '../../../../../services/settings/sales';
import SettingHeaderComponent from '../../components/settingHeaderComponent';
import { useSearchParams } from 'react-router-dom';

export default function SalesOrder({ activeTab }) {
	const [searchParams, setSearchParams] = useSearchParams();
	const [tab, setTab] = useState('General');
	const [isEdit, setIsEdit] = useState(false);
	const [isCreateForm, setIsCreateForm] = useState(false);
	const [customFieldError, setCustomFieldError] = useState(false);
	const [error, setError] = useState(false);
	const [customFieldForm, setCustomFieldForm] = useState({
		label_name: '',
		data_type: '',
		status: false,
		is_mandatory: false,
	});
	const [loader, setLoader] = useState({
		isLoader: true,
		isSave: false,
		isGetData: true,
		isGetDataFieldCustomisation: true,
		isSaveFieldCustomisation: true,
	});
	const [generalForm, setGeneralForm] = useState({});
	const [form, setForm] = useState({
		terms_and_conditions: '',
		customer_notes: '',
		additional_charge_fields: false,
		round_off_preferences: false,
		enable_salesperson: false,
	});

	const getShowUndoChanged = () => {
		const hasChanged = JSON.stringify(generalForm) !== JSON.stringify(form);
		setIsEdit(hasChanged);
	};

	const handleSalesOrder = async () => {
		try {
			setLoader((prev) => ({
				...prev,
				isLoader: true,
				isSave: true,
			}));
			setIsEdit(false);
			const res = await UpdateSalesOrderGeneral(form);
			if (res.success) {
				toast.success(res.message);
				getSalesOrder();
			} else {
				setIsEdit(true);
				toast.error(res.message);
			}
		} catch (error) {
			setIsEdit(true);
		} finally {
			setLoader((prev) => ({
				...prev,
				isLoader: false,
				isSave: false,
			}));
		}
	};

	const getSalesOrder = async () => {
		try {
			setLoader((prev) => ({
				...prev,
				isLoader: true,
				isGetData: true,
			}));

			const { sales_order_settings } = await getSalesOrderGeneral();
			var data = {
				additional_charge_fields:
					sales_order_settings.additional_charge_fields !== null
						? stringToBool(sales_order_settings.additional_charge_fields)
						: false,
				round_off_preferences: sales_order_settings.round_off_preferences || '',
				enable_salesperson:
					sales_order_settings.enable_salesperson !== null
						? stringToBool(sales_order_settings.enable_salesperson)
						: false,
				terms_and_conditions:
					sales_order_settings.terms_and_conditions !== null &&
						sales_order_settings.terms_and_conditions !== 'null'
						? sales_order_settings.terms_and_conditions
						: '',
				customer_notes:
					sales_order_settings.customer_notes !== null &&
						sales_order_settings.customer_notes !== 'null'
						? sales_order_settings.customer_notes
						: '',
			};
			setForm(data);
			setGeneralForm(data);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setLoader((prev) => ({
				...prev,
				isLoader: false,
				isGetData: false,
			}));
		}
	};
	const handleCustomField = () => { };

	useEffect(() => {
		if (form) {
			getShowUndoChanged();
		}
	}, [form]);


	const setUrlSearchParams = () => {
		const url = new URLSearchParams();
		if (tab === 'General') {
			url.set('type', 'sales-order-general')
		} else {
			url.set('type', 'field-customisation');
		}
		setSearchParams(url);
	}

	useEffect(() => {
		setUrlSearchParams()
	}, [tab]);


	const setFilterFromUrl = () => {
		setTab(searchParams.get('type') === 'field-customisation' ? 'Field Customisation' : 'General')
	}

	useEffect(() => {
		setFilterFromUrl()
	}, [])

	useEffect(() => {
		if (tab === 'General') {
			getSalesOrder();
		}
	}, [searchParams]);

	return (
		<div>
			<SettingHeaderComponent
				title={activeTab}
				buttons={tab === 'Field Customisation' ? [
					{
						id: 1,
						button: 'Add New Custom Field',
						add: true,
						close: false,
						disabled: false,
						handler: () => {
							setIsCreateForm(true)
						},
						className: 'btn-primary',
					},
				] : [
					{
						id: 1,
						disabled: !isEdit || loader.isLoader && loader.isSave,
						className: 'btn-primary',
						add: false,
						close: false,
						button: 'Save',
						loader: loader.isLoader && loader.isSave,
						handler: () => {
							handleSalesOrder();
						},
					},
					isEdit && {
						id: 2,
						disabled: false,
						className: 'btn-primary',
						add: false,
						close: false,
						button: 'Undo Changed',
						handler: () => {
							setIsEdit(false);
							getSalesOrder();
						},
					}
				].filter((button) => button !== false)}
			/>
			<div
				className="py-2 d-flex justify-content-between align-items-center"
				style={{ backgroundColor: '#DADDEC', position: 'sticky', top: 0, zIndex: 100 }}
			>
				<div>
					<ul className="nav mt-2">
						{['General', 'Field Customisation'].map((item, index) => (
							<li
								key={index}
								className="nav-item"
							>
								<div
									className={`tab-link ${tab === item ? 'active' : ''} d-flex align-items-center`}
									onClick={() => {
										setTab(item);
										setIsCreateForm(false);
									}}
								>
									{item}
								</div>
							</li>
						))}
					</ul>
				</div>
				{isCreateForm && (
					<div className="d-flex gap-4 align-items-center px-2">
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#0066ff' }}
							onClick={() => handleCustomField()}
						>
							Save
						</div>
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#555B67' }}
							onClick={() => setIsCreateForm(false)}
						>
							Cancel
						</div>
					</div>
				)}
			</div>
			{tab === 'General' ? (
				<SalesOrderGeneral
					form={form}
					setForm={setForm}
					error={error}
					setError={setError}
					loader={loader}
				/>
			) : (
				<SalesOrderFieldCustomisation
					isCreateForm={isCreateForm}
					setIsCreateForm={setIsCreateForm}
					setCustomFieldForm={setCustomFieldForm}
					customFieldForm={customFieldForm}
					setCustomFieldError={setCustomFieldError}
					customFieldError={customFieldError}
				/>
			)}
		</div>
	);
}
